module.exports = "<div class=\"spinner-table\">\n    <div class=\"spinner-wrapper\">\n        <div class=\"spinner-loader\">\n            Loading…\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/spinner.html
// module id = 1043
// module chunks = 7